// extracted by mini-css-extract-plugin
export default {"spinner_container":"loading-spinner_spinner_container__40f72","loading_spinner":"loading-spinner_loading_spinner__Ye7oo"};